import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';
import ReactTable from 'react-table';
import styled from 'styled-components';
import { FORM_ACTIONS } from 'constants/form';
import COLORS from 'constants/colors';

const TableWrapper = styled.div`
  width: 930px;
  overflow-x: auto;
  margin: 50px auto;
`;

const LinkNav = styled(Link)`
  text-decoration: underline;
  cursor: pointer;
  color: ${COLORS.LINK};
  text-align: center;
  &:hover {
    color: ${COLORS.LINK};
  }
  &:active {
    color: ${COLORS.LINK};
  }
`;

const tableColumns = [
  {
    columns: [
      {
        Header: 'Program Code',
        accessor: 'code',
        width: 300,
        Cell: row => {
          return (
            <LinkNav
              to={{
                pathname: `/curriculum-analytics/programs/${row.original.id}`,
                state: {
                  formType: FORM_ACTIONS.CREATE,
                  student: row.original,
                },
              }}
            >
              {row.original.code}
            </LinkNav>
          );
        },
      },
      {
        Header: 'Program Name',
        accessor: 'name',
        width: 300,
      },

      {
        Header: 'Course Type',
        accessor: 'program_type',
        width: 300,
      },
    ],
  },
];
class ProgramList extends PureComponent {
  render() {
    const { programsList } = this.props;

    return (
      <TableWrapper>
        <ReactTable
          data={programsList}
          className="-striped -highlight"
          manual
          filterable={false}
          sortable={false}
          resizable={false}
          columns={tableColumns}
          style={{ textAlign: 'center' }}
        />
      </TableWrapper>
    );
  }
}

export default ProgramList;
